import type { Block, BlockType } from '@/components/canvas/blocks/types';
import { getBlockDefinition } from '@/components/canvas/blocks/registry/blockRegistry';
import type { FC } from 'react';

export interface BlocksPropertiesProps {
  block: Block;
}

export const BlocksProperties: FC<BlocksPropertiesProps> = ({ block }) => {
  const def = getBlockDefinition(block.type);
  if (!def) {
    return (
      <div className="text-sm text-muted-foreground">暂不支持此功能块类型</div>
    );
  }
  const Properties = def.Properties;
  return <Properties block={block as never} />;
};

export function getBlockPropertyViewId(type: BlockType): string {
  return `block:${type}`;
}

export function isBlockPropertyViewId(viewId: string): viewId is `block:${BlockType}` {
  return viewId.startsWith('block:');
}

export function blockTypeFromPropertyViewId(viewId: string): BlockType | null {
  if (!isBlockPropertyViewId(viewId)) return null;
  const type = viewId.slice('block:'.length);
  return getBlockDefinition(type as BlockType) ? (type as BlockType) : null;
}
